import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/FmsTypes";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";
import {
    ContractSummarySearch, ContractDetailSearch,
    ContractResult,
    StatementResult,
    BillResult,
    AccountOpenApplyFields,
    AccountOpenResult,
    ApprovalFields,
} from "./ContractManageTypes";

class ContractManageService {

    //合约管理列表
    async contractSummaryPage(searchVo: ContractSummarySearch) {
        const apiUrl = "/contract/page";
        return await httpRequest.post<IPage<ContractResult>>(apiUrl, searchVo);
    }

    //合约管理列表(客户)
    async customerSummaryPage(searchVo: ContractSummarySearch) {
        const apiUrl = "/contract/pageByCustomer";
        return await httpRequest.post<IPage<ContractResult>>(apiUrl, searchVo);
    }

    //对账单列表
    async statementPage(searchVo: ContractDetailSearch) {
        const apiUrl = "/contract/pageSoas";
        return await httpRequest.post<IPage<StatementResult>>(apiUrl, searchVo);
    }

    //账单列表
    async billPage(searchVo: ContractDetailSearch) {
        const apiUrl = "/contract/pageBills";
        return await httpRequest.post<IPage<BillResult>>(apiUrl, searchVo, { timeout: 300000 });
    }

    //合约管理导出
    async contractExport(searchVo: ContractDetailSearch) {
        const apiUrl = "/contract/export";
        return await httpRequest.postFile(apiUrl, searchVo, { timeout: LONG_REQUEST_TIMEOUT });
    }

    //根据调额单号查询
    async one(adjustCode: string) {
        const apiUrl = "/contract/one/" + adjustCode;
        return await httpRequest.get<ContractResult>(apiUrl);
    }

    //账户初始化
    async monthAccountOpen(vo: AccountOpenApplyFields) {
        const apiUrl = "/contract/monthAccountOpen";
        return await httpRequest.post<boolean>(apiUrl, vo);
    }

    //开户记录列表
    async monthAccountOpenPage(searchVo: ContractDetailSearch) {
        const apiUrl = "/contract/monthAccountOpen/page";
        return await httpRequest.post<IPage<AccountOpenResult>>(apiUrl, searchVo);
    }

    //开户申请审核
    async approval(vo: ApprovalFields) {
        const apiUrl = "/contract/monthAccountOpen/approval";
        return await httpRequest.post<boolean>(apiUrl, vo);
    }

    //合约终止
    async terminate(code: string) {
        const apiUrl = "/contract/terminate/" + code;
        return await httpRequest.get<any>(apiUrl);
    }

}

export const contractManageService = new ContractManageService();
